.zoom-percentage {
  line-height: 30px;
}
